import * as homeActions from '../home/redux/apiCall';

import { KuposButton, KuposCheckbox, KuposInput, KuposModal, SvgHome } from '../common';

import { AppData } from '../../services';
import CommonService from '../../services/commonService';
import React from 'react';
import Termsandconditions from './TermsAndConditions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';

function ChangeTicketPage({ t, history, actions }) {
  const [checkbox, setCheckbox] = useState(false);
  const [termAndConditionError, setTermAndConditionError] = useState(false);

  const [RUT, setRUT] = useState('');
  const [RUTError, setRUTError] = useState(false);

  const [emailId, setEmailId] = useState('');
  const [emailIdError, setEmailIdError] = useState(false);

  const [changeTicketDetails, setChangeTicketDetails] = useState({});
  const [seatDetails, setSeatDetails] = useState('');

  const [showTncModal, setShowTncModal] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem('changeTicketDetails')) {
      history.push('/');
    } else {
      setChangeTicketDetails(JSON.parse(sessionStorage.getItem('changeTicketDetails')));
      let temp = JSON.parse(sessionStorage.getItem('changeTicketDetails'));
      if (temp && temp.seat_Details) {
        for (const property in temp.seat_Details.seat_details) {
          if (temp.seat_Details.seat_details[property].travel_operator_pnr === temp.int_number) {
            setSeatDetails(temp.seat_Details.seat_details[property]);
            break;
          }
        }
      }
    }

    // return () => sessionStorage.removeItem('changeTicketDetails');
  }, []);

  const onBlur = (text, type) => {
    if (!text) {
      if (type === 'email') {
        setEmailIdError({
          message: 'CHANGE_TICKET.INSERT_YOUR_EMAIL_ID',
        });
      }
    }

    if (type === 'RUT') {
      if (!CommonService.isRutValid(text)) {
        setRUTError({
          message: 'CHANGE_TICKET.INSERT_A_VALID_RUT',
        });
      }
      setRUT(CommonService.formatRut(text));
    }
  };

  const AmPmTime = (time = '') => {
    const temp = time.split(':');
    if (parseInt(temp[0]) < 12) return 'AM';
    else return 'PM';
  };

  const handleSubmit = () => {
    let error = 0;
    if (!checkbox) {
      setTermAndConditionError(true);
      error++;
    }
    if (!RUT) {
      setRUTError({
        message: 'CHANGE_TICKET.INSERT_A_VALID_RUT',
      });
      error++;
    }
    if (!emailId) {
      setEmailIdError({
        message: 'CHANGE_TICKET.INSERT_YOUR_EMAIL_ID',
      });
      error++;
    }

    if (error > 0) return 0;

    // loadTicketDetails({
    //   url: ApiUrls.ticketDetails(changeTicketPNR, ''),
    // }).then(res => {});

    // actions
    //   .apiCall({
    //     url: AppData.BASE_URL + 'api/pullman/base/contact_info',
    //     method: 'POST',
    //     // data: data,
    //   })
    //   .then(res => {
    //     // console.log('res', res);
    //     // setResponse(res);
    //     // setLoading(false);
    //     // setShowModal(true);
    //   });

    setLoading(true);

    actions
      .apiCall({
        url: AppData.BASE_URL + 'api/pullman/bus_bookings/validate_change_boleto',
        method: 'POST',
        data: {
          pnr_number: changeTicketDetails.int_number,
          rut: RUT,
          email: emailId,
        },
      })
      .then((res) => {
        setLoading(false);
        // if (res && res.success) {
        sessionStorage.setItem(
          'changeTicketDetailsResponse',
          JSON.stringify({
            // result: {
            //   voucher: {
            //     origin_name: res.data.origin_name,
            //     destination_name: res.data.destination_name,
            //   },
            // },
            ...res.data,
            origin_name: changeTicketDetails.origin_name,
            destination_name: changeTicketDetails.destination_name,
          }),
        );
        history.push('/es/change-ticket-response');
        // } else {
        //   sessionStorage.setItem(
        //     'changeTicketDetailsResponse',
        //     JSON.stringify({
        //       success: false,
        //     }),
        //   );

        //   history.push('/es/change-ticket-response');
        // }
      })
      .catch((err) => {
        setLoading(false);
        sessionStorage.setItem('changeTicketDetailsResponse', JSON.stringify(err.data));
        history.push('/es/change-ticket-response');
      });
  };

  return (
    <div className="content-container">
      <div className="pullman-section-primary-row">
        <div className="pullman-section-primary-row-main-heading black-text margin-T20 margin-B30">
          {t('CHANGE_TICKET.TICKET_CHANGE_HEADING')}
        </div>
      </div>
      <div className="change-your-ticket-page">
        {(changeTicketDetails.is_our_ticket || changeTicketDetails.seat_Details) && (
          <div className="kupos-card-custom">
            <div className=" kupos-card  change-your-ticket-page-left">
              <div className="pullman-section-primary-row align-items-start">
                <div className="pullman-section-primary-row-main-heading black-text font13">
                  {/* {t('CHANGE_TICKET.PASSENGER_DATA')} */}
                  PULLMAN BUS
                </div>
                <div className="pullman-section-primary-row-underline margin-B15"></div>
              </div>
              <div className="change-your-ticket-page-left-ticket-code mb-1">
                <span className="change-your-ticket-page-left-ticket-code-label font10 bold-text">
                  {t('CHANGE_TICKET.TICKET_CODE')}{' '}
                </span>
                <span className="change-your-ticket-page-left-ticket-code-no font9 bold-text">
                  {changeTicketDetails && changeTicketDetails.pnr_number}
                </span>
              </div>
              <div className="change-your-ticket-page-left-ticket-code">
                <span className="change-your-ticket-page-left-ticket-code-label font10 bold-text">
                  {t('CHANGE_TICKET.CODE')}{' '}
                </span>
                <span className="change-your-ticket-page-left-ticket-code-no font9 bold-text">
                  {changeTicketDetails && changeTicketDetails.int_number}
                </span>
              </div>
              <div className="change-your-ticket-page-left-seat">
                <span className="change-your-ticket-page-left-seat-label font11 bold-text">
                  {t('CHANGE_TICKET.SEAT')} :{' '}
                </span>
                <span className="change-your-ticket-page-left-seat-no font10 ">
                  {seatDetails && seatDetails.seat_number}
                </span>
              </div>
              <div className="change-your-ticket-page-left-location">
                <div className="change-your-ticket-page-left-location-origin">
                  <img src="/images/search-bar/search-bar-origin.svg" alt="" />
                  <div className="change-your-ticket-page-left-location-origin-name black-text font11">
                    {changeTicketDetails && changeTicketDetails.origin_name}
                  </div>
                </div>
                <div className="change-your-ticket-page-left-location-terminal-name font10 ">
                  {changeTicketDetails &&
                    changeTicketDetails.boarding_details &&
                    changeTicketDetails.boarding_details.long_address}
                </div>
                <div className="change-your-ticket-page-left-location-destination">
                  <img src="/images/search-bar/search-bar-destination.svg" alt="" />
                  <div className="change-your-ticket-page-left-location-origin-name black-text font11">
                    {changeTicketDetails && changeTicketDetails.destination_name}
                  </div>
                </div>
                <div className="change-your-ticket-page-left-location-terminal-name font10 ">
                  {/* {changeTicketDetails.arrival_details.address} */}
                  {changeTicketDetails &&
                    changeTicketDetails.arrival_details &&
                    changeTicketDetails.arrival_details.long_address}
                </div>
              </div>
              <div className="change-your-ticket-page-left-date">
                <span className="change-your-ticket-page-left-date-label bold-text font10">
                  {t('CHANGE_TICKET.DATE')} :{' '}
                </span>
                <span className="change-your-ticket-page-left-date-no font10">
                  {changeTicketDetails && changeTicketDetails.travel_date}
                </span>
              </div>
              <div className="change-your-ticket-page-left-time">
                <span className="change-your-ticket-page-left-time-label font10 bold-text">
                  {t('CHANGE_TICKET.TIME')} :{' '}
                </span>
                <span className="change-your-ticket-page-left-time-no font10">
                  {changeTicketDetails && changeTicketDetails.depart_time}{' '}
                  {changeTicketDetails && AmPmTime(changeTicketDetails.depart_time)}
                </span>
              </div>
              <div className="hr"></div>
              <div className="change-your-ticket-page-left-cost">
                <div className="change-your-ticket-page-left-cost-label black-text font12 ">
                  {t('CHANGE_TICKET.PRICE')}
                </div>
                <div className="change-your-ticket-page-left-cost-value black-text font12">
                  CLP ${seatDetails && seatDetails.fare}
                </div>
              </div>
            </div>
            <div className="change-your-ticket-page-left-condition-container">
              <div className="change-your-ticket-page-left-condition-container-label font11">
                {t('CHANGE_TICKET.STATUS')}
              </div>
              <div className="change-your-ticket-page-left-condition-container-value font9">
                {changeTicketDetails && changeTicketDetails.status}
              </div>
            </div>
          </div>
        )}
        <div
          className="kupos-card change-your-ticket-page-right"
          style={{
            width:
              changeTicketDetails.is_our_ticket || changeTicketDetails.seat_Details
                ? '68%'
                : '100%',
          }}
        >
          <div className="change-your-ticket-page-right-heading font13 black-text margin-B20">
            {t('CHANGE_TICKET.ENTER_YOUR_DATA_FOR_THE_CHANGE')}
          </div>
          <span className="label font10" style={{ paddingLeft: '5px' }}>
            {'RUT'}
          </span>
          <KuposInput
            placeholder={'RUT'}
            type="text"
            className="kupos-border"
            value={RUT}
            onChange={(value) => {
              setRUT(value);
              setRUTError(null);
            }}
            onBlur={(value) => onBlur(value, 'RUT')}
            error={RUTError ? true : false}
            height={40}
            errorMessage={RUTError ? t(RUTError.message) : null}
          />

          <span className="label font10 margin-T20 d-inline-block" style={{ paddingLeft: '5px' }}>
            {t('HOME.EMAIL_ID')}
          </span>
          <KuposInput
            placeholder={t('HOME.EMAIL_ID')}
            type="text"
            className="kupos-border"
            value={emailId}
            onChange={(value) => {
              setEmailId(value);
              setEmailIdError(null);
            }}
            onBlur={(value) => onBlur(value, 'email')}
            error={emailIdError ? true : false}
            height={40}
            errorMessage={emailIdError ? t(emailIdError.message) : null}
          />
          <div className="margin-T30 d-flex align-items-center">
            <KuposCheckbox
              checked={checkbox}
              onChange={() => {
                if (!checkbox) {
                  setTermAndConditionError(false);
                }
                setCheckbox(!checkbox);
              }}
            />
            <span
              className="font9 pointer"
              onClick={() => {
                setShowTncModal(true);
              }}
            >
              {t('CHANGE_TICKET.TNC')}
            </span>
          </div>
          <div className="margin-T30 d-flex flex-column align-items-center">
            {termAndConditionError && (
              <span className="red-text font9 margin-B10">
                {t('CHANGE_TICKET.PLEASE_ACCEPT_TNC')}
              </span>
            )}
            <KuposButton
              disabled={loading}
              onClick={() => {
                handleSubmit();
              }}
            >
              {loading ? t('CHANGE_TICKET.LOADING') : t('CHANGE_TICKET.CHANGE')}
            </KuposButton>
          </div>
        </div>
      </div>
      <KuposModal
        ariaLabel="tnc-pnr-modal-outer"
        size={'xl'}
        onHide={() => setShowTncModal(false)}
        showModal={showTncModal}
      >
        <div className="tnc-pnr-modal">
          <Termsandconditions t={t} />
          <div className="close-button pointer" onClick={() => setShowTncModal(false)}>
            <SvgHome name="close" />
          </div>
        </div>
      </KuposModal>
    </div>
  );
}

// export default withTranslation('common')(ChangeTicketPage);

function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(ChangeTicketPage));



// WEBPACK FOOTER //
// ./src/features/pages/ChangeTicketPage.js